<div class="instruction" *ngIf="klass != 'hide'" (click)="hide()"  (touchstart)="hide()">
  <ng-content></ng-content>
  <div class="speech1"></div>
  <div class="speech2"></div>
</div>
